<template>
    <div class="flex flex-direction align-center justify-center padding-tb-lg" v-if="rule">
        <textarea v-if="hasTest" :value="hasTestMsg" style="width: 100%; height: 200px;">{{hasTestMsg}}</textarea>
        <template v-for="(file,fi) in files" >
            <div v-if="filesIndex<0 || filesIndex==fi" fotoo-input-file=""
                 class="popup-upload-box flex align-center justify-between"
                 :style="'background:linear-gradient(to right,#EEF2F2 0%, #EEF2F2 '+file.progress+'%, white 0%, white 100%)'">
                <div class="flex align-center justify-between" style="width: calc(100% - 35px);">
                    <div class="text-enter" style="width: calc(100% - 25px);word-break: break-all;">{{file.name||file.exif.name}}({{(file.size/1024/1024).toFixed(2)}}M)</div>
                    <div class="icon-up">UP</div>
                </div>
                <input fotoo-input-file="" type="file"
                       @change="uploadfile($event,fi)"
                       title="" name="thumb" class="popup-upload">
                <div @click="deleteFile(fi)"
                     class="flex align-center justify-end"
                     style="position: absolute; right:10px;z-index: 1;">
                    <div class="icon-de">DE</div>
                </div>

            </div>
        </template>
        <div fotoo-input-file="" class="popup-upload-box new" v-if="files.length<rule.countMax && (filesIndex<0 || files.length<1)">
            + 点我上传
            <input fotoo-input-file="" type="file"
                   @change="uploadfile($event,-1)"
                   title="" name="thumb" class="popup-upload">
        </div>
        <div class="ruleStr margin-top">{{ruleStr}}</div>
        <el-dialog class="upload" top="35vh"
                title="温馨提示"
                :visible.sync="centerDialogVisible"
                width="90%" center>
            <div class="text-gray text-df text-center text-400" style="white-space: pre-line;">
                {{ruleErr}}
            </div>
            <div slot="footer" class="dialog-footer solid-top padding-top">
                <div class="text-green text-df" @click="centerDialogVisible = false">知道了</div>
            </div>
        </el-dialog>
        <div @click="compiled" class="round bg-green text-white flex align-center justify-center text-df text-400" style="width: 310px;height: 40px; bottom: 20px; position: fixed;">确定</div>
    </div>
</template>
<script>
  import App from '../util/comfun'
  import * as qiniu from "qiniu-js"
  //contentType https://www.coderbusy.com/archives/597.html
  const fileTypes={
    Document:{
      contentType: {
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document":"word",
        "application/msword":"word",
        "application/pdf":"pdf",
        "application/vnd.ms-powerpoint":"ppt",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation":"ppt",
        "application/vnd.ms-excel":"excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":"excel",
        "application/zip":"zip",
        "application/x-rar":"zip",
        "application/x-7z-compressed":"zip",
        "application/x-zip-compressed":"zip",
      },
      ruleStr:'单个限制最大{maxSize}M，仅支持Word、PDF、PPT、Excel、zip、rar、7z 等格式',
      '上传格式有误':'上传格式有误，仅支持Word、PDF、\n' + 'PPT、Excel、zip、rar、7z 等格式',
      __type:'file',
      __exif_type:4,
    },
    Audio:{
      contentType: {
        "audio/mpeg": "mp3",
        "audio/mp4": "m4a",
        "audio/x-wav": "wav",
        "audio/aac": "aac",

        "audio/x-m4a": "m4a",
        "audio/wav": "wav",
        "audio/vnd.dlna.adts": "aac",
      },
      ruleStr:'单个限制{maxDuration}分钟以内，最大{maxSize}M，支持mp3、m4a、wav、aac，等主流音频格式',
      '上传格式有误':'上传格式有误，仅支持mp3、m4a、\n' + 'wav、aac等主流音频格式',
      __type:'audio',
      __exif_type:5,
    },
  }
  export default {
    data () {
      return {
        files:[{percentage:20}],
        filesIndex:-1,//修改时>-1
        centerDialogVisible:false,
        rule:null,
        ruleStr:'',
        ruleErr:'上传格式有误，仅支持Word、PDF、\n' + 'PPT、Exce、lzip、rar、7z 等格式',
        hasTest:App.hasTest(),
        hasTestMsg:'hasTestMsg.start',
      }
    },
    components:{

    },
    methods:{
      async init(){
        this.filesIndex=this.options.index
        wxlite.setStorageSync('token',this.options.token)
        if(this.options.files){
          try{
            this.files=JSON.parse(decodeURIComponent(this.options.files))
            console.log('this.files',this.files)
          }catch(e){
            this.files=[]
          }
        }
        await this.getQnToken()
        this.getDetail()
      },
      getDetail(){
        App.demand('fotoo/activity/activity','GET',{activityId:this.options.activityId}).then(res=>{
          this.detail=res.data
          this.rule={
            "id": "1405282721181284307",
            "activityId": "16443",
            "enable": 1,
            "activityMaterialType": "Document",
            "name": "上传文档",
            "tips": "333333333333333333\nfasddsaafadfdsfsdafds\n\n\nasdfsdafasdf\n\nasdfasdf\n",
            "minSize": 0,
            "maxSize": 800,
            "minDuration": null,
            "maxDuration": null,
            "minWordsCount": null,
            "maxWordsCount": null,
            "countMin": 1,
            "countMax": 10,
            "quality": 0,
            "isOrigin": 1,
            "customize": "{}",
            "maxDurationCN": 0
          }
          this.ruleStr=fileTypes[this.options.type].ruleStr
            .replace('{maxSize}',this.rule.maxSize)
            .replace('{maxDuration}',this.rule.maxDurationCN)
          console.log('this.rule',this.rule)
          /*
          this.detail.activityMaterialTypeRefs.some(rule=>{
            if(rule.activityMaterialType==this.options.type){
              rule.maxDurationCN=rule.maxDuration/60
              this.rule=rule
              this.ruleStr=fileTypes[this.options.type].ruleStr
                .replace('{maxSize}',rule.maxSize)
                .replace('{maxDuration}',rule.maxDurationCN)
              console.log('this.rule',this.rule)
            }
          })
          */
        })
      },

      async getQnToken(){
        this.qn=(await App.demand('fotoo/activity/upload/token/{activityId}','GET',{activityId:this.options.activityId})).data
        //console.log('this.qn',this.qn)
      },
      async checkFailed(file){
        this.ruleErr=''
        file.mask=fileTypes[this.options.type].contentType[file.type]
        console.log('checkFailed '+file.type,file.mask)
        if(!file.mask){
          this.ruleErr=fileTypes[this.options.type]['上传格式有误']
        }
        let fileSizeCN=App.mkb(file.size)
        if(file.size<this.rule.minSize*1024*1024 ){
          this.ruleErr=`文件大小要求最少${this.rule.minSize}M
当前${fileSizeCN}，请重新选择`
        }
        if(file.size>this.rule.maxSize*1024*1024){
          this.ruleErr=`文件大小要求最多${this.rule.maxSize}M
当前${fileSizeCN}，请重新选择`
        }
        if(this.options.type=='Audio' && !this.ruleErr){
          let duration=-1
          try{
            console.log('checkFailed.start',duration)
            duration=await this.getAudioDuration(file)
          }catch (e){
            console.log('checkFailed.fail ',e)
          }
          console.log('checkFailed.duration',duration)
          file.duration=duration
          if(duration>-1){
            console.log('duration',duration)
            let durationCN=App.durationCN(duration)
            if(duration<this.rule.minDuration){
              let minDuration=App.durationCN(this.rule.minDuration)
              this.ruleErr=`音频时长要求最少${minDuration}
当前${durationCN}，请重新选择`
            }
            if(duration>this.rule.maxDuration){
              let maxDuration=App.durationCN(this.rule.maxDuration)
              this.ruleErr=`音频时长要求最多${maxDuration}
当前${durationCN}，请重新选择`
            }
          }
        }
        console.log('checkFailed.ruleErr',this.ruleErr)
        if(this.ruleErr){
          this.centerDialogVisible=true
          return true
        }
        return false
      },
      async getAudioDuration(file){
        console.log('getAudioDuration.path',window)//此代码在ios系统会报错，跳出获取时长业务
        const audio = new Audio()
        file.path=this.getObjectUrl(file)
        console.log('getAudioDuration.path',file.path)
        audio.src = file.path
        while (isNaN(audio.duration) || audio.duration === Infinity) {
          //console.log('audio.duration',audio.duration)
          await new Promise(resolve => setTimeout(resolve, 200));
          // 设置随机播放时间
          audio.currentTime = 10000000 * Math.random();
        }
        return audio.duration
      },
      getObjectUrl(file) {
        let url = null;
        console.log('getObjectUrl.start')
        if (window.createObjectURL != undefined) {
          // basic
          url = window.createObjectURL(file);
        } else if (window.webkitURL != undefined) {
          // webkit or chrome
          url = window.webkitURL.createObjectURL(file);
        } else if (window.URL != undefined) {
          // mozilla(firefox)
          url = window.URL.createObjectURL(file);
        }
        return url;
      },
      //图片上传 回显 赋值
      async uploadfile($event,fi=-1) {
        const file = $event.target.files[0];
        let time=parseInt((file.lastModifiedDate||new Date())/1000)
        console.log('target.file',{
            name:file.name,
            size:file.size,
            path:file.path,
            type:file.type,
            time:time,
        })
        console.log('target.file2',file.lastModifiedDate/1000)
        if(await this.checkFailed(file)){//检查失败
          this.centerDialogVisible=true
          return
        }
        let suffix=file.name.split('.')
        let upfile={
          'name': file.name,
          'size': file.size,
          'time': time,
          'path': file.path,
          'type': fileTypes[this.options.type].__type,
          'status': 0,
          'exif': {
            'suffix': suffix[suffix.length-1],
            'mark': file.mask,
            'name': file.name,
            'size': file.size,
            'type': fileTypes[this.options.type].__type,
            'hasSource': 1,
            'duration':file.duration,
            time:time,
          },
          'thumb': 'https://assets.pfotoo.com/poster/'+file.mask+'.png',
          'coverInfo': {'width': 330, 'height': 330, 'url': 'https://assets.pfotoo.com/poster/'+file.mask+'.png'},
          'x': 0,
          'y': 0,
          'progress': 0,
          'url': '',
          'imgUrl': 'https://assets.pfotoo.com/poster/'+file.mask+'.png',
          'bucket': this.qn.bucket,
        }
        if(false && this.options.type=='Audio'){
          upfile.thumb='https://assets.pfotoo.com/images/audio/thumb.png'
          upfile.imgUrl=upfile.thumb
          upfile.coverInfo.url=upfile.thumb
        }
        if(fi<0){//push
          this.files.push(upfile)
          this.filesCurren=this.files.length-1
        }else{
          //this.files[fi]=upfile
          this.files.splice(fi,1,upfile)
          this.filesCurren=fi
        }
        console.log(fi,this.files[fi])
        this.qiniuUpload(file,this.filesCurren)
      },
      getFileKey(file){
        let item=JSON.stringify(file)
        let name=item+parseInt(new Date()/1)
        return 'H5'+App.CryptoJS.CryptoJS.SHA256(name).toString()
      },
      qiniuUpload(file,filesCurren){
        let key = this.getFileKey(file);//null; //这是上船后返回的文件名，这里为了避免重复，加上了时间戳和随机数
        var config = {
          useCdnDomain: true, //表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
          region: null, //选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域。  华北地区
          domain: this.qn.domain, //这里是后端返回的Bucket地址
          chunkSize: 3, //每个分片的大小，单位mb，默认值3
          //forceDirect: true, //直传还是断点续传方式，true为直传,默认false
          debugLogLevel:'INFO', //INFO | WARN | ERROR | OFF，允许程序在控制台输出日志，默认为 OFF
        };
        var putExtra = {
          fname: file.name, //文件原始文件名
          params: {},
          //mimeType: [] || null,
          // ...config,
        };
        var observable = qiniu.upload(file, key, this.qn.token, putExtra, config);
        observable.subscribe({
          next: (result) => {
            //主要用来展示进度
            // console.log(result);
            console.log({
              message: `已上传${result.total.percent.toFixed(0)}%`,
              forbidClick: true,
              duration: 0,
            });
            this.files[filesCurren].progress=result.total.percent.toFixed(0)/1
          },
          error: (err) => {
            //上传错误后触发
            console.log(err);
            console.log({
              message: err.message,
              forbidClick: true,
              duration: 0,
            });
          },
          complete: (result) => {
            console.log('qiniuUpload.complete',result)
            //上传成功后触发。包含文件地址。
            if(this.files[filesCurren].exif.duration==-1 && result.avinfo){
              this.files[filesCurren].exif.duration=result.avinfo.audio.duration
            }
            this.files[filesCurren].progress=100
            this.files[filesCurren].status=1
            this.files[filesCurren].url=this.qn.domain+'/'+result.key
            console.log(filesCurren,this.files[filesCurren]);
            if(this.filesIndex>-1){
              this.compiled()
            }else{
              this.postMessage()
            }
          },
        });
      },
      deleteFile(fi){
        //console.log(fi)
        this.files.splice(fi,1)
        this.postMessage()
      },
      navigateBack(){
        if(App.hasTT()){
          tt.miniProgram.navigateBack()
        }else{
          wx.miniProgram.navigateBack()
        }
      },
      postMessage(){
        if(App.hasTT()){
          tt.miniProgram.postMessage({data:{action:'h5file',files:this.files,globalDataKey:'attachments'}})
        }else{
          wx.miniProgram.postMessage({data:{action:'h5file',files:this.files,globalDataKey:'attachments'}})
        }
      },
      compiled(){
        //检查上传
        let upingFlag=false
        this.files.some(f=>{
          if(f.status==0 || f.progress<100){
            upingFlag=true
          }
        })
        if(upingFlag){
          this.ruleErr='上传中，请等待上传完成'
          this.centerDialogVisible=true
          return
        }
        this.postMessage()
        setTimeout(()=>{
          this.navigateBack()
        })

      },
    },
    mounted(){
      console.log=($0,$1='')=>{
        this.hasTestMsg=JSON.stringify($0,null,4)+","+JSON.stringify($1,null,4)+'\n'+this.hasTestMsg
        console.info($0,$1)
      }
      this.options=this.$route.params
      console.log('this.$route.params',this.options)
      this.init()
    },
  }
</script>
<style scoped>
    .popup-upload-box[fotoo-input-file] {
        position: relative;
        width: 355px;
        min-height: 40px;
        border: 0.5px solid #E0E0E0;
        border-radius: 2px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #353535;
        line-height: 25px;
        margin-bottom: 10px;
        background:linear-gradient(to right,#EEF2F2 0%, #EEF2F2 var(--percentage)%, white 0%, white 100%);
        padding: 0 10px;
        box-sizing: border-box;
    }
    .popup-upload-box[fotoo-input-file].new {
        width: 355px;
        height: 40px;
        border: 0.5px solid #E0E0E0;
        border-radius: 2px;
        color: #3dc4a7ff;
        font-size: 20px;
        font-face: PingFangSC;
        font-weight: 400;
        line-height: 40px;
        letter-spacing: 0;
        paragraph-spacing: 0;
        text-align: center;
    }
    .popup-upload[fotoo-input-file] {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        visibility: visible;
        opacity: 0;
        border: 0;
    }
    .upload .el-dialog{
        width: 280px;
        background: #FFFFFF;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 10px 0 0;
    }
    .upload .el-dialog__header{
        padding: 0;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        text-align: center;
    }
    .upload .el-dialog__headerbtn{
        display: none;
    }
    .upload .el-dialog__body{
        padding: 10px 0;
    }
    .upload .el-dialog__footer{
        padding: 15px 0;
    }
    .ruleStr{
        width: 355px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #F6727E;
        letter-spacing: 0;
    }
    .icon-de,.icon-up{
        width: 15px;
        height: 15px;
        text-indent: -999px;
        background-image: url("https://assets.pfotoo.com/h5file/de.svg");
        min-width: 15px;
    }
    .icon-up{
        background-image: url("https://assets.pfotoo.com/h5file/up.svg");
        margin-left: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/upload-attachment.vue